module.exports = __webpack_public_path__ + "static/media/r7s5.6775becd.jpg";